/**
 * FoodCard — Unified entry point for all card variants.
 * Memoized to prevent unnecessary re-renders.
 */
import { memo } from 'react';
import RecommendationVariant from './foodcard/RecommendationVariant';
import DiscoverVariant from './foodcard/DiscoverVariant';
import PostVariant from './foodcard/PostVariant';
import SearchVariant from './foodcard/SearchVariant';

const FoodCard = memo(({ variant, ...props }) => {
  switch (variant) {
    case 'recommendation': return <RecommendationVariant {...props} />;
    case 'discover': return <DiscoverVariant {...props} />;
    case 'post': return <PostVariant {...props} />;
    case 'search': return <SearchVariant {...props} />;
    default: return <RecommendationVariant {...props} />;
  }
});

FoodCard.displayName = 'FoodCard';

export default FoodCard;
export { RecommendationVariant, DiscoverVariant, PostVariant, SearchVariant };
